import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import axios from "axios";
import { FILE_URL } from "src/constants";
import { Modal, Fade, Backdrop } from "@material-ui/core";
// const baseUrl = "https://gritdev.s3.us-east-2.amazonaws.com/";
const useStyles = makeStyles((theme) => ({
  customDialog: {
    backgroundColor: "#ffffff",
    padding: theme.spacing(2),
    maxWidth: "700px",
  },
}));
const ViewModal = (props: any) => {
  const { modalContent, open, handleClose, isDirector } = props;
  const [data, setData] = useState<any>(null);
  const [NoteList, setNoteList] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [noteModalVisible, setNoteModalVisible] = useState(false);
  const classes = useStyles();
  const location = useLocation();

  useEffect(() => {
    const getViewDetailData = async () => {
      if (modalContent && modalContent.id) {
        setLoading(true);
        try {
          const url = props.selectedTab === 0 ? "getListOneCheque" : "getOneSubscrition"
          const response = await axios.get(`/api/payment/${url}/${modalContent.id}`);
          // if (response.data?.length > 0) {
          // setData(response?.data?.data[0]);
          console.log(response?.data
            , "response............view")
          // } else {
          if (response?.data?.status) {
            setData(response?.data);
          }
          // setData(null);
          // }
        } catch (error) {
          console.error("Error fetching data", error);
        } finally {
          setLoading(false);
        }
      }
    };

    getViewDetailData();
  }, [modalContent]);

  const CloseButton = () => {
    return (
      <button
        onClick={handleClose}
        style={{ border: "none", background: "none" }}
      >
        <CloseIcon />
      </button>
    );
  };
  function CFS(text: any = "") {
    console.log(text, "text...........")
    const safeText = text === null || text === undefined ? "" : String(text);
    return safeText
      ?.split(/([.!?]\s+)/) // Split by sentence-ending punctuation followed by space.
      ?.map((sentence: any) => sentence?.charAt(0)?.toUpperCase() + sentence?.slice(1))
      ?.join('');
  }

  const changeChequeName = (value: string) => {
    if (value === 'Cheque') {
      return 'Check'
    }
    return value
  }

  function planFrequently(key: any) {
    switch (key) {
      case 'yearly':
        return 'yr'

      default:
        return key
    }
  }
  function CheckDetailsRender() {
    return (
      <div style={{ position: "relative" }}>
        <p>
          <strong>Name:</strong> {CFS(data?.data?.user?.firstName)} {CFS(data?.data?.user?.lastName)}
        </p>
        <p>
          <strong>Email:</strong> {data?.data?.user?.email}
        </p>
        <p>
          <strong>Status:</strong> {CFS(data?.data?.status)}
        </p>
        <p>
          <strong>School Organization:</strong> {CFS(data?.data?.school?.name)}
        </p>
        <p>
          <strong>Payment Method:</strong> {changeChequeName(CFS(data?.data?.payment?.payment_method))}
        </p>
        <p>
          <strong>Payment Amount:</strong> ${data?.data?.payment?.payment_amount ?? "N/A"}
        </p>
        <p>
          <strong>Payment Status:</strong> {CFS(data?.data?.payment?.status)}
        </p>
        <p>
          <strong>Agreement</strong>
          <a href={FILE_URL + "/" + data?.data?.payment?.agreement} target="_blank" rel="noopener noreferrer">
            &nbsp; {"View"}
          </a>
        </p>
        <p>
          <strong>Payment Invoice</strong>
          {(() => {
            try {
              const resultData = JSON.parse(data?.data?.payment?.result_data);
              return (
                <a href={FILE_URL + "/" + resultData?.invoice} target="_blank" rel="noopener noreferrer">
                  &nbsp; {"View"}
                </a>
              );
            } catch (error) {
              // console.error("Failed to parse JSON or construct URL", error);
              return null;
            }
          })()}
        </p>
        {/* Plan Table */}        
        <div style={{ marginBottom: 10 }}>
          <strong>Plan:</strong>      
          {data?.data?.plan ? (
            <TableContainer component={Paper} style={{ marginTop: 16 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <strong>Title</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Description</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Price</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Coaches</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Status</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>{CFS(data?.data?.plan?.title)}</TableCell>
                    <TableCell>{CFS(data?.data?.plan?.description)}</TableCell>
                    <TableCell>${data?.data?.plan?.price}/{planFrequently(data?.data?.plan?.payment_frequency_type)}</TableCell>
                    <TableCell>{data?.data?.plan?.coachs || "N/A"}</TableCell>
                    <TableCell>{CFS(data?.data?.plan?.status)}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <p>No Plan Available</p>
          )}
        </div>

        {/* Addons Table */}
        <div>
          <strong>Addons:</strong>
          {data?.data?.payment?.addons?.length > 0 ? (
            <TableContainer component={Paper} style={{ marginTop: 16 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <strong>Title</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Description</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Price</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data?.data?.payment?.addons?.map((addon: any, index: number) => (
                    <TableRow key={index}>
                      <TableCell>{CFS(addon?.title)}</TableCell>
                      <TableCell>{CFS(addon?.description)}</TableCell>
                      <TableCell>${addon?.price}/{planFrequently(addon?.payment_frequency_type)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <p>No Addons Available</p>
          )}
        </div>
      </div>
    )
  }
  function MemberShipDetailsRender() {


    const handleOpenNoteModal = (noteList: any) => {
      const noteData = noteList;
      if (noteData) {
        const list = JSON.parse(noteData);
        setNoteList(list)
      } else {
        console.error("Note data is undefined or invalid");
      }
      setNoteModalVisible(true);
    };

    const handleCloseNoteModal = () => {
      setNoteModalVisible(false);
    };
    return (
      <div style={{ position: "relative" }}>
        {location.pathname === "/admin/inquire" && ( <p>
          <strong>Note:</strong>
          {/* {data?.membership?.note} */}
          <button onClick={() => { handleOpenNoteModal(data?.membership?.note) }} className="view-page-inner" >
            View
          </button>
        </p>
        )
      }
        <p>
          <strong>Name:</strong> {CFS(data?.data?.user?.firstName)} {CFS(data?.data?.user?.lastName)}
        </p>
        <p>
          <strong>Email:</strong> {data?.data?.user?.email}
        </p>
        <p>
          <strong>Status:</strong> {CFS(data?.data?.membership?.status)}
        </p>
        <p>
          <strong>School Organization:</strong> {CFS(data?.data?.school?.name)}
        </p>
        <p>
          <strong>Subscription Type:</strong> {changeChequeName(CFS(data?.data?.membership?.subscription_type))}
        </p>
        {data?.membership?.subscription_type === "stripe" && <p>
          <strong>Subscription ID:</strong> {CFS(data?.data?.membership?.subscription_no)}
        </p>}
        <div>
          {
            data?.data?.paymentHistory?.length > 0 ?
              data?.data?.paymentHistory.map((item: any) => {
                console.log(item, "item.............")
                return (
                  <div key={item?.id} style={{ borderWidth: 1 }}>
                    <p>
                      <strong>Payment Method:</strong> {changeChequeName(CFS(item.payment?.payment_method))}
                    </p>
                    <p> <strong>Plan Amount: </strong>
                    
                    ${(() => {
    const planPrice =  item.payment?.payment_method === "free" ? item?.plan?.price : item.price ?? 0;
    const purchasableAddonIds = modalContent?.purchasableAddonIds || [];
    console.log('ViewModal - purchasableAddonIds:', purchasableAddonIds);
    const addonsTotal = data?.data?.addon?.reduce((sum:any , a:any ) => {
      // Only add addon price if it was purchased (in purchasableAddonIds list)
      const isPurchased = purchasableAddonIds.includes(a?.addon?.id);
      console.log('Addon ID:', a?.addon?.id, 'isPurchased:', isPurchased, a?.price );
      if (isPurchased) {
        return sum + (item.payment?.payment_method === "free" ? a?.addon?.price : a?.price );
      }
      return sum;
    }, 0) ?? 0;
   const total = planPrice + addonsTotal;

// If payment type is "cheque", no 3% fee
// const finalAmount =
//   item.payment?.payment_method === "cheque"
//     ? total
//     : total * 1.03;

// return finalAmount.toFixed(2);
return total.toFixed(2);
  })()}

                    </p>
                   
                    <p>
  <strong>Payment Amount:</strong>
  ${(() => {
    if (item.payment?.payment_method === "free") {
      return "0.00";
    }

    const savedAmount = Number(item.payment?.payment_amount) || 0;
    const planPrice = item.payment?.payment_method === "free" ? item?.plan?.price : item.price ?? 0;
    const purchasableAddonIds = modalContent?.purchasableAddonIds || [];
    const addonsTotal = data?.data?.addon?.reduce((sum: any, a: any) => {
      const isPurchased = purchasableAddonIds.includes(a?.addon?.id);
      if (isPurchased) {
        return sum + (item.payment?.payment_method === "free" ? a?.addon?.price : a?.price);
      }
      return sum;
    }, 0) ?? 0;
    const baseTotal = Number(planPrice || 0) + Number(addonsTotal || 0);

    // Some older Stripe records saved only the base subscription amount.
    // Add the card fee for display only when it is missing; avoid double-adding it for newer records.
    if (item.payment?.payment_method === "stripe" && savedAmount <= baseTotal) {
      return (baseTotal * 1.03).toFixed(2);
    }

    return savedAmount.toFixed(2);
  })()}
</p>

                    <p>
                      <strong>Payment Status:</strong> {CFS(item.payment?.status)}
                    </p>

                    <p>
                      <strong>Agreement</strong>
                      <a href={FILE_URL + "/" + item?.payment?.agreement} target="_blank" rel="noopener noreferrer">
                        &nbsp; {"View"}
                      </a>
                    </p>
                    <p>
                      <strong>Payment Invoice</strong>
                      {(isDirector === true && item?.payment?.checkstatus === false) ? ': Pending' : (() => {
                        try {
                          const resultData = JSON.parse(item?.payment?.result_data);
                          return (
                            <a href={FILE_URL + "/" + resultData?.invoice} target="_blank" rel="noopener noreferrer">
                              &nbsp; {"View"}
                            </a>
                          );
                        } catch (error) {
                          // console.error("Failed to parse JSON or construct URL", error);
                          return null;
                        }
                      })()}
                    </p>
                    {/* Plan Table */}
                    <div style={{ marginBottom: 10 }}>
                      <strong>Plan:</strong>
                      {item?.plan ? (
                        <TableContainer component={Paper} style={{ marginTop: 16 }}>
                          <Table>
                            <TableHead>
                              <TableRow>
                                <TableCell>
                                  <strong>Title</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Description</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Price</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Coaches</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Status</strong>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              <TableRow>
                                <TableCell>{CFS(item?.plan?.title)}</TableCell>
                                <TableCell>{CFS(item?.plan?.description || "N/A")}</TableCell>
                                <TableCell>${item?.price}/{planFrequently(item?.plan?.payment_frequency_type)}</TableCell>
                                <TableCell>{item?.plan?.coachs || "N/A"}</TableCell>
                                <TableCell>{CFS(item?.plan?.status)}</TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </TableContainer>
                      ) : (
                        <p>No Plan Available</p>
                      )}
                    </div>
                  </div>
                )
              })
              : null
          }
        </div>

        <Modal
          open={noteModalVisible}
          onClose={handleCloseNoteModal}
          closeAfterTransition={true}
          BackdropComponent={Backdrop}
          BackdropProps={{ timeout: 500 }}
        >
          <Fade in={noteModalVisible}>
            <div
              style={{
                backgroundColor: "white",
                padding: "20px",
                borderRadius: "10px",
                maxWidth: "650px",
                margin: "auto",
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "80%",
              }}
            >
              <div className="note-inner-mod">
                <h2>Note</h2>
                <span
                style={{cursor:"pointer"}}
                  onClick={handleCloseNoteModal}
                >
                  <CloseIcon />
                </span>
              </div>
              <div className="note-inner-list">
              {NoteList?.map((row: any, index: number) => {
                return (
                  <>

                 <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tr className="membership-over">
                      {row?.date_note !== null &&
                       <td style={{ border: "1px solid #ddd", padding: "8px",width:"20%" }}>
                        {row?.date_note} </td>}
                      <td style={{ border: "1px solid #ddd", padding: "8px" }}><p className="s">{row?.note !== "" ? row?.note : ""}</p></td></tr>
                    </table>
                  </>
                )

              })}
</div>

            </div>
          </Fade>
        </Modal>

        {/* Addons Table */}
        <div>
          <strong>Addons:</strong>
          {data?.data?.addon?.length > 0 ? (
            <TableContainer component={Paper} style={{ marginTop: 16 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <strong>Title</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Description</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Price</strong>
                    </TableCell>
                    <TableCell>Invoice</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data?.data?.addon?.filter((addon: any) => {
                    const purchasableAddonIds = modalContent?.purchasableAddonIds || [];
                    // Only show purchased addons (in purchasableAddonIds list)
                    return purchasableAddonIds.includes(addon?.addon?.id);
                  }).map((addon: any, index: number) => (
                    <TableRow key={index}>
                      <TableCell>{CFS(addon?.addon?.title)}</TableCell>
                      <TableCell>{CFS(addon?.addon?.description)}</TableCell>
                      <TableCell>${addon?.price}/{planFrequently(addon?.addon?.payment_frequency_type)}</TableCell>
                      <TableCell style={{width:"18%"}}>    {(() => {
                        try {
                          const resultData = JSON.parse(addon?.payment?.result_data);
                          return (
                            <a href={FILE_URL + "/" + resultData?.invoice} target="_blank" rel="noopener noreferrer">
                              &nbsp; {"View"}
                            </a>
                          );
                        } catch (error) {
                          // console.error("Failed to parse JSON or construct URL", error);
                          return null;
                        }
                      })()}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <p>No Addons Available</p>
          )}
        </div>
      </div>
    )
  }
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth={true}
      classes={{ paper: classes.customDialog }}
    >
      <DialogTitle>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>View Details</div> <div>{CloseButton()}</div>
        </div>
      </DialogTitle>

      <DialogContent>
        {loading ? (
          <p>Loading...</p>
        ) : data ? props.selectedTab === 0 ? CheckDetailsRender() : MemberShipDetailsRender() : (
          <p>No content available</p>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ViewModal;



// WEBPACK FOOTER //
// ./src/shared/components/ViewModal/index.tsx